/**
 * MyYL page
 */
app.pws = (function() {
    "use strict";
    var loaded = false,
        preview = false,
        pageData = {
            profile: null,
            theme: null,
            categories: null,
            showFeatureBlocks: false
        },
        cookieData = {},
        categories = null,
        pinnedPackages = [],
        pws = {
            "themes": [
                {
                    "theme_desktop" : "/img/themes/seed-to-seal.jpg",
                    "theme_mobile" : "/img/themes/seed-to-seal-mobile.jpg"
                }, {
                    "theme_desktop" : "/img/themes/promise-to-families.jpg",
                    "theme_mobile" : "/img/themes/promise-to-families-mobile.jpg"
                }, {
                    "theme_desktop" : "/img/themes/seed-to-seal2.jpg",
                    "theme_mobile" : "/img/themes/seed-to-seal2-mobile.jpg"
                }, {
                    "theme_desktop" : "/img/themes/healthy-lifestyle.jpg",
                    "theme_mobile" : "/img/themes/healthy-lifestyle-mobile.jpg"
                }
            ]
        },
        products = null,
        randomSpotlight,

        // primary has become featured_1
        packageRank = {
            ADDITIONAL: 0,
            PRIMARY: 1,
            SECONDARY: 2,
            FEATURED_1: 1,
            FEATURED_2: 3,
            FEATURED_3: 4
        },

        self = {

        /**
         * Called on page load
         */
        init: function(isSkavaPage) {
            app.page.showLoader();
            app.productcard.init();

            pageData.profile = app.main.getProfile();
            pageData.showFeatureBlocks = mode !== 'live';
            pageData.all_products_url = app.main.getAllProductsURL();

            if (isSkavaPage) {
                $('#page').addClass('hide-pws');
                // $('#skava-loading-overlay').addClass('loading');
            } else {
                $('#page').removeClass('hide-pws');
            }

            var cookie = app.cookie.get();
            if (cookie) {
                cookieData = JSON.parse(cookie);
                if (cookieData.memberID == undefined) {
                     cookieData.memberID = app.main.getProfile().member_id;
                     app.cookie.set(JSON.stringify(cookieData));
                }
            }

            /**
             * SOME PARTIAL AND SPOTLIGHT MAGIC HERE
            */

            // randomize spotlight

            randomSpotlight = self.checkSpotlightHeadlines([
                app.main.lang('spotlight_foundation_headline'),
                app.main.lang('spotlight_savvy_headline'),
                app.main.lang('spotlight_video_headline')
            ]);

            if (randomSpotlight) {
                pageData.randomSpotlight = true;
            }

            // use defaults in case an order has never been explicitly set
            var module_order_array = ['pkgs', 'member-benefits', 'my-products', 'contact-me', 'my-events'];

            // PROFILE
            if (pageData.profile.module_order && pageData.profile.module_order !== '-') {
                module_order_array = pageData.profile.module_order.split(',');
            }

            // special case where a new module has been added, but in admin it was never saved to the profile
            if (!module_order_array.includes('pkgs')) {
                module_order_array.unshift('pkgs');
            }

            // todo: remove spotlight code
            // // we want to show a spotlight, but it's not in their custom module_order list, so let's force it onto the end
            // if (!module_order_array.includes('spotlight')) {
            //     module_order_array.push('spotlight');
            // }

            // // if spotlight is undefined - pull it from the partial module_order list
            // if (!randomSpotlight || randomSpotlight === 'undefined') {
            //     // module_order_array = _.without(module_order_array, 'spotlight');
            //     for (var i=0; i<module_order_array.length; i++) {
            //         if (module_order_array[i] == 'spotlight') {
            //             module_order_array.splice(i, 1);
            //             break;
            //         }
            //     }
            // }

            // render partials helper; if one is spotlight, return randomized spotlight from above
            Handlebars.registerHelper('whichPartial', function (arg) {
                if (module_order_array[arg] === 'spotlight') {
                    // return randomSpotlight;
                    return false;
                } else {
                    return module_order_array[arg];
                }
            });
            /**
             * END PARTIAL AND SPOTLIGHT MAGIC
            */

            Handlebars.registerHelper('sprintf', function(str) {
                var vals = [];
                // Skip the first and last arguments
                for (var i=1; i<arguments.length-1; ++i) {
                    vals.push(arguments[i]);
                }
                return app.main.strReplace(str, vals);
            });

            Handlebars.registerHelper('map', function(location) {
                return location.split(' ').join('+');
            });

            Handlebars.registerHelper('featureHeadline', function(index) {
                return app.main.lang('feature_copy_'+ (index+1));
            });

            if (categories) {
                // previously loaded
                // todo: rewrite this to avoid dupe code
                self.populateSkavaPackages();
                self.populateData();
                self.render();
                self.renderProducts();

                if (self.isPreview()) {
                    self.initPreview();
                }

            } else {
                var file = app.main.getSettings().skavaEnabled ? 'categories-v2.json' : 'categories.json';
                var url = assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ file + cb;

                // dev and test category data needs to match prod for testing
                if (app.main.getCountryCode() == 'au' && ['local', 'dev'].includes(mode)) {
                    console.log('using local categories.json');
                    url = 'json/en-au/categories.json';
                }

                $.getJSON(url)
                    .done(function(cats) {
                        categories = cats;

                        // categories.forEach(function(cat) {
                        //     cat.products = [];
                        // });

                        self.loadProducts(function() {
                            self.populateSkavaPackages();
                            self.populateData();
                            self.render();
                            self.renderProducts();
                            app.productsearch.enable();

                            if (self.isPreview()) {
                                self.initPreview();
                            }
                        });

                    }).fail(function(a, b, c) {
                        // todo: error handling
                    });
            }
        },

        populateSkavaPackages: function() {
            // Subscription packages
            if (app.main.getSettings().skavaEnabled) {
                var packages = app.main.getProfile().targeted_packages,
                    bundles = {
                        featured: [],
                        secondary: false,
                        other: []
                    };

                if (!packages) {
                    packages = [];
                }

                packages.forEach(function(pkg) {
                    if (pkg.config) {
                        // special for localhost dev
                        if (mode == 'local') {
                            var localLink = pkg.url.substring(pkg.url.indexOf('#'));
                            pkg.url = '/pws.html'+ localLink;
                        }

                        switch (pkg.config.rank_id) {
                            case packageRank.FEATURED_1:
                            case packageRank.FEATURED_2:
                            case packageRank.FEATURED_3:
                                // for sorting
                                pkg.order = pkg.config.rank_id;
                                bundles.featured.push(pkg);
                            break;

                            case packageRank.SECONDARY:
                                bundles.secondary = pkg;
                            break;

                            default:
                                var packageProducts = pkg.config.product_ids;
                                var otherPackage = packageProducts.kits.concat(packageProducts.monthly).concat(packageProducts.products);
                                var finalList = [];

                                for (var x = 0; x < otherPackage.length; x++) {
                                    var product = self.getProductByID(otherPackage[x]);

                                    if (typeof otherPackage[x] == 'object') {
                                        product = self.getProductByID(otherPackage[x].item_id, 'item_id');
                                    }

                                    if (product) {
                                        finalList.push(product);
                                    }
                                }

                                bundles.other.push({
                                    order: pkg.config.order,
                                    name: pkg.config.name,
                                    products: finalList,
                                    link: pkg.url,
                                    preselected: pkg.config.preselected ? true : false
                                });
                            break;
                        }
                    }
                });

                // use a default package if primary isn't set
                if (!bundles.featured.length) {
                    bundles.featured.push({
                        config: app.enroll.getDefaultPackage(),
                        url: '#bwm/default'
                    });
                }

                app.main.sort(bundles.featured, 'order');
                app.main.sort(bundles.other, 'order');
                pageData.bundles = bundles;
                // console.log('subscriptions?', app.skava.hasSubscriptions());
                pageData.hasSubscriptions = app.skava.hasSubscriptions();
            }
        },

        /**
         * Load products while everything else is loading/rendering
         */
        loadProducts: function(finishedCb) {
            // products have already been loaded
            if (products) {
                finishedCb();
                return;
            }

            if (app.main.getSettings().skavaEnabled) {
                $.getJSON(assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ app.main.getCountryCode() +'/products-v2.json'+ cb)
                    .done(function(data, beKits) {
                        var items = data;

                        if (app.main.checkInStock(items) === true) {
                            app.products.groupVariants(items, true);
                            products = defiant.getSnapshot(items);
                            app.products.setSubscribed(products);

                            finishedCb();
                        }
                    });

            } else {
                var productsURL = assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ app.main.getCountryCode() +'/products.json'+ cb;

                // dev and test product data needs to match prod for testing
                if (app.main.getCountryCode() == 'au' && ['local', 'dev'].includes(mode)) {
                    console.log('using local products.json');
                    productsURL = 'json/en-au/products.json';
                }

                // legacy
                $.getJSON(productsURL)
                // $.getJSON('json/products.json')
                    .done(function(items) {
                        if (app.main.checkInStock(items) === true) {
                            app.products.groupVariants(items, true);
                            // console.log(JSON.stringify(items));
                            products = defiant.getSnapshot(items);

                            // special for Australia
                            app.products.parseAuProducts();

                            finishedCb();
                        }
                    }
                );
            }
        },

        // return loaded products for use in product search
        // has already had defiant applied
        getProducts: function() {
            return products;
        },

        // helper function to allow some product related functions to be used from app.enroll
        setProducts: function(items) {
            if (!products) {
                products = items;
            }
        },

        /**
        * Make sure spotlights have a headline - if not ready for market, wont have headline
        */
        checkSpotlightHeadlines: function(args) {
            var populatedSpotlights = [];
            if (args[0] != null && args[0] !== '' && args[0] !== 'undefined') {
                populatedSpotlights.push('yl-foundation');
            }
            if (args[1] != null && args[1] !== '' && args[0] !== 'undefined') {
                populatedSpotlights.push('savvy-feature');
            }
            if (args[2] != null && args[2] !== '' && args[0] !== 'undefined') {
                populatedSpotlights.push('seed-to-seal-video');
            }
            if (populatedSpotlights.length < 1) {
                return false;
            }
            // return one random
            // randomSpotlight = populatedSpotlights[Math.floor(Math.random()*populatedSpotlights.length)];

            // nope, always seed-to-seel for now
            randomSpotlight = 'seed-to-seal-video';
            return randomSpotlight;
        },

        /**
         * Once external data has been loaded, prepare pageData for the template
         * profile is optional, used in preview mode
         */
        populateData: function(profile) {
            // pageData.showFeatureBlocks = showFeatureBlocks;

            if (profile !== undefined) {
                pageData.profile = profile;
            }
            // pageData.lang = app.main.getLanguageData();
            pageData.preview = preview;

            // used in preview mode to show in the 'My website URL' section
            if (preview) {
                pageData.pws_url = 'www.MyYL.com/'+ app.main.getSitePath();
            }

            pageData.profile.yl_culture = app.main.getYLCulture();
            pageData.profile.yl_lang = app.main.getLanguageCode();
            pageData.profile.yl_country = app.main.getCountryCode().toUpperCase();

            // will show events counter if there is at least one public event; check logic in loop below
            pageData.showEventCounter = true;

            var i = pageData.profile.events.length;

            while (i--) {
                var event = self.parseEvent(pageData.profile.events[i]);

                if (event.public === false) {
                    // remove the private event
                    pageData.profile.events.splice(i, 1);
                }
            }

            if (cookieData.culture) {
                pageData.chosen_culture = cookieData.culture;

            } else {
                pageData.chosen_culture = pageData.profile.culture;
            }

            pageData.chosen_language = pageData.chosen_culture.split('-')[0];

            if (!pageData.profile.selected_theme) {
                pageData.profile.selected_theme = 1;
            }

            var theme = pws.themes[pageData.profile.selected_theme - 1],
                key = 'theme'+ pageData.profile.selected_theme;


            // populate theme copy from language data
            theme.headline = app.main.lang(key +'_name');
            theme.blurb = app.main.lang(key +'_description');

            pageData.theme = theme;
            pageData.pws = pws;

            // random banners for skava members
            if (app.main.getSettings().skavaEnabled) {
                var rnd = Math.floor(Math.random() * 3) + 1;

                // pair the two banners vs. random for each
                pageData.primaryClass = 'primary-'+ rnd;
                pageData.secondaryClass = 'secondary-'+ rnd;
            }

            // construct contact form url
            pageData.contact_url = '/contact/'+ pageData.profile.culture +'/'+ pageData.profile.member_id +'/';

            if (location.hostname === 'localhost') {
                pageData.contact_url = 'http://localhost:8000/contact/'+ pageData.profile.culture +'/'+ pageData.profile.member_id +'/';
            }

            pageData.become_member_url = app.main.getEnrollURL();

            // cache buster value
            pageData.cache_buster = cb;

            // pageData.randomSpotlight = self.checkSpotlightHeadlines([
            //     app.main.lang('spotlight_foundation_headline'),
            //     app.main.lang('spotlight_savvy_headline'),
            //     app.main.lang('spotlight_video_headline')
            // ]);

            // attempt get a properly formatted national/international tel: uri from display_phone
            if (app.main.getProfile().display_phone) {
                var number = libphonenumber.parsePhoneNumberFromString(app.main.getProfile().display_phone, app.main.getProfile().country.toUpperCase());

                if (number) {
                    pageData.display_phone_uri = number.getURI();

                } else {
                    pageData.display_phone_uri = 'tel:'+ pageData.profile.display_phone;
                }

                pageData.display_text_uri = 'sms:'+ pageData.profile.display_phone;
            }

            pageData.promoURL = promoURL[mode];
            pageData.enrollmentEnabled = app.main.checkCustomEnrollmentEnabled();

            pageData.promoEnabled = true;

            if (app.main.getSettings().skavaEnabled) {
                pageData.promoEnabled = false;
            }

            console.log('promo enabled: '+ pageData.promoEnabled);
        },

        /**
         * Return the image url for the selected starter kit
         */
        getStarterKitImage: function(id) {
            // parse custom_enrollment config, get the kit, get the product data for that kit, use part_number
            var starterKitImage = '',
                kit = self.getProductByID(id);

            if (kit) {
                // remove any 'D' chars from product_id to generate this URL
                // starterKitImage = promoURL[mode] +'img/kits/'+ kit.part_number.split('D').join('') +'.jpg';
                starterKitImage = kit.image_url;

            } else {
                // if chosen kit is no longer available, find one to fallback on
                var kits = defiant.json.search(products, '//*[enrollment="true" and in_stock="true"]');
                app.main.sort(kits, 'name');

                if (kits.length) {
                    //starterKitImage = promoURL[mode] +'img/kits/'+ kits[0].part_number +'.jpg';
                    starterKitImage = kits[0].image_url;

                } else {
                    starterKitImage = '../img/logo-white.svg';
                }
            }

            return starterKitImage;
        },

        /**
         * Render the template after data has loaded and add any event listeners
         */
        render: function() {
            $('#page').empty().html(app.main.getTemplate('pws', pageData));

            app.page.initGlobalAlerts();

            // var sections = ['my-events','contact-me','my-products','member-benefits'];

            app.page.setID('');
            app.page.addClickHandler('[data-page]');

            $('#seed-to-seal-clickthru').click(function() {
                // $('video').get(0).play();
                $('#seed-to-seal-clickthru').css('display', 'none');
            });

            var modalvideo = new ModalVideo('.bgvid-play');

            // email me pop up - copy to clipboard
            new Clipboard('.member-photo-wrap .email-me');

            $('.member-photo-wrap .email-me').click(function() {
                $('.copied-message').show()
                    .on('click', function() {
                        $(this).hide();
                    });

                setTimeout(function() {
                    $('.copied-message').hide();
                }, 3000);
            });

            $('[data-scrollto]').on('click', function(e) {
                e.preventDefault();

                if (document.getElementById($(this).data('scrollto'))) {
                    app.main.scrollTo($(this).data('scrollto'));

                } else {
                    var cookie = app.cookie.get(),
                        cookieData = { 'scrollTo': '' };

                    if (cookie) {
                        cookieData = JSON.parse(cookie);
                    }
                    cookieData.scrollTo = $(this).data('scrollto');
                    app.cookie.set(JSON.stringify(cookieData));
                    app.page.loadPage('');
                }
            });

            $('#calendar-add-list, #select-list').on('mousedown touchstart', function(e) {
                e.stopPropagation();
            });

            // init the add to calendar buttons
            $('.button-add-to-calendar').on('click', function(e) {
                e.preventDefault();

                var event = pageData.profile.events[parseInt($(this).data('event-index'), 10)],
                    pos = $(this).offset(),
                    cal = createCalendar({
                        data: {
                            start: event.start_date_time,
                            end: event.end_date_time,
                            duration: 60,   // we have an end time, so this will be ignored
                            title: event.name,
                            description: event.description,
                            location: event.location
                        }
                    });

                $('#calendar-add-list').html(cal).css({
                    top: pos.top - (app.main.getSettings().skavaEnabled ? 11 : 5),
                    left: pos.left - 15
                }).prepend('<span>'+ app.main.lang('btn_add_to_calendar') +'</span>').show();

                $('body,.carousel').on('mousedown touchstart', function(e) {
                    $('#calendar-add-list').hide();
                    $(document).off('mousedown touchstart');
                });
            });

            var cookie = app.cookie.get();
            if (cookie) {
                var cookieData = JSON.parse(cookie);
                if (cookieData.scrollTo) {
                    app.main.scrollTo(cookieData.scrollTo);
                    delete cookieData.scrollTo;
                    app.cookie.set(JSON.stringify(cookieData));
                }
            }

            if (!pageData.profile.spotlight_enabled) {
                $('.spotlight').css('display', 'none');
            }

            $('#ga-module-custom-enrollment-cta').on('click', function(e) {
                e.preventDefault();
                app.page.loadPage('build');
                app.main.track('CE', 'cta-enroll-module-clicked');
            });

            if (app.main.checkCustomEnrollmentEnabled()) {
                $('.reset-enrollment').on('click', function(e) {
                    e.preventDefault();
                    app.enroll.reset();

                    var href = $(this).attr('href');
                    setTimeout(function() {
                        window.location.href = href;
                    }, 300);
                });
            }

            app.page.hideLoader();
            app.page.initHelpTips();

            // app.cart.init(products);
        },

        /**
         * Render products separately
         */
        renderProducts: function() {
            app.modal.init();
            // category list now coming from categories.json
            // populate it with select products (if set in profile) or default (if not)
            var list = [];

            // always reset in case of reload
            categories.forEach(function(cat) {
                cat.products = [];
            });

            if (pageData.profile.selected_product_ids) {
                list = pageData.profile.selected_product_ids.split(',');

            } else {
                // no selected products? use the default list
                list = app.main.getSettings().default_product_ids.split(',');
            }

            if (list.length > 0) {
                list.forEach(function(i) {
                    var product = self.getProductByID(i);

                    if (product) {
                        var cat = self.getCategoryByID(product.categories[0].hasOwnProperty('id') ? product.categories[0].id : product.categories[0]);

                        if (cat) {
                            cat.products.push(product);

                        } else {
                            console.log('Category with id '+ product.categories[0] +' not found');
                        }

                    } else {
                        // console.log('Product with product_id '+ i +' not found');
                    }
                });
            }

            pageData.categories = categories;

            // set character count max to 250 for product descriptions
            // products.src.forEach(function(i) {
            //     if (i.description && i.description.length > 250) {
            //         i.description = i.description.substring(0, 250);
            //         i.description = i.description.substring(0, i.description.lastIndexOf(' ')) +'…';
            //     }
            // });

            if (pageData.enrollmentEnabled) {
                // reset this in case of back-button
                pinnedPackages = [];

                // add the default package as first item if possible
                try {
                    pinnedPackages.push(app.main.getProfile().custom_enrollment.config);

                } catch(err) {
                    // console.log('default package is not enabled');
                }

                // load pinned packages, if any exist
                var targeted_packages = app.main.getProfile().targeted_enrollments;

                if (app.main.getSettings().skavaEnabled) {
                    targeted_packages = app.main.getProfile().targeted_packages;
                }

                if (targeted_packages) {
                    targeted_packages.forEach(function(item) {
                        var pkg = item.config;
                        if (pkg.pinned && pinnedPackages.length < 10) {
                            pinnedPackages.push(pkg);
                        }
                    });
                }

                if (pinnedPackages.length) {
                    // use default package if there is only a single pinned package because the first is always the default package
                    // if the default package is not present, this will show the first pinned package instead
                    pageData.singlePackage = pinnedPackages.length == 1 ? pinnedPackages[0] : false;
                    pageData.pinnedPackages = pinnedPackages;

                    pinnedPackages.forEach(function(pkg) {
                        if (typeof pkg === 'string') {
                            pkg = JSON.parse(pkg);
                        }

                        pkg.imageURL = self.getStarterKitImage(pkg.product_ids.kits[0]);
                    });
                }

                pageData.promoURL = promoURL[mode];
            }

            $('#my-products').removeClass('loading').empty();

            // Option to disable legacy product carousels if needed
            if (app.main.getSettings().disableProducts === true) {
                // remove categories to prevent product carousel rendering
                console.log('legacy products disabled');
                delete pageData.categories;

                // delete the container
                $('#my-products').remove();

            } else {
                $('#my-products').html(app.main.getTemplate('my-products', pageData));
            }

            $('#member-benefits').html(app.main.getTemplate('member-benefits', pageData));

            if (app.cart.getCartItems()) {
                if (app.cart.getCartItems().length) {
                    $('.view-cart-container').show();
                }

            } else {
                $('.view-cart-container').hide();
            }

            $('.learn-more').on('click', function(e) {
                e.preventDefault();
                var product = self.getProductByID($(this).attr('data-part-number'), 'part_number');

                app.modal.load('product-modal', {
                    product: product
                });

                $('#modal a').on('click', app.modal.close);

                app.main.track('CE Products', $(this).data('trackingaction'), $(this).attr('data-part-number'));

            });

            // Consumer packages
            /*
            if (app.main.getSettings().skavaEnabled) {
                pageData.consumer = {
                    name: 'Myyl Clean Home Products Package',
                    products: pageData.categories[0].products
                };
                $('#consumer-products').removeClass('loading').html(app.main.getTemplate('consumer-products', pageData));
            }
            */

            // Subscription packages
            if (app.main.getSettings().skavaEnabled) {
                if (pageData.bundles.other.length > 0) {
                    $('#subscription-packages').removeClass('loading');
                    $('#subscription-packages-inner').html(app.main.getTemplate('subscription-packages', pageData));

                } else {
                    $('#subscription-packages').remove();
                }
            }

            document.querySelectorAll('.carousel').forEach(function(slider) {
                if (slider.children.length > 1) {
                    if (slider.children.length == 2) {
                        $('.control', $(slider).parent()).addClass('minimal');
                    }

                    var sliderProps = {
                        1379: Math.min(slider.children.length, 4),
                        1050: Math.min(slider.children.length, 4),
                        800: Math.min(slider.children.length, 3),
                        600: Math.min(slider.children.length, 2)
                    };

                    if (app.main.getSettings().skavaEnabled) {
                        sliderProps[1500] = Math.min(slider.children.length, 4);
                    }

                    var carousel = new Siema({
                        selector: slider,
                        duration: 300,
                        easing: 'ease-out',
                        perPage: sliderProps,
                        startIndex: 0,
                        draggable: true,
                        multipleDrag: true,
                        threshold: 100,
                        dragThreshold: 10,
                        loop: false,
                        rtl: false,
                        onInit: function() {
                            self.updateCarouselCounter(this);
                        },
                        onChange: function() {
                            self.updateCarouselCounter(this);
                        },
                        onDragStart: function() {
                            app.productcard.setIsDragging(true);
                        },
                        onDragEnd: function() {
                            window.setTimeout(function() {
                                app.productcard.setIsDragging(false);
                            }, 50);
                        }
                    });

                    $('.control.prev', $(carousel.selector).parent()).on('click', function(e) {
                        e.preventDefault();
                        carousel.prev();
                    });

                    $('.control.next', $(carousel.selector).parent()).on('click', function(e) {
                        e.preventDefault();
                        carousel.next();
                    });

                } else {
                    // if 1 item or less, hide the control arrows
                    $('.control', $(slider).parent()).hide();
                }
            });

            app.main.setEnrollCheck();

            if (app.main.getSettings().product_card_enabled) {
                app.productcard.enable('pws');

            } else {
                // init quantity select
                $('.add-to-cart .selected').off().on('click', function() {
                    var pos = $(this).offset(),
                        $parent = $(this).parent(),
                        $select = $('#select-list');

                    if ($parent.hasClass('is-active')) {
                        self.closeSelect();

                    } else {
                        self.closeSelect();
                        $parent.addClass('is-active');
                        $(window).on('resize', self.closeSelect);

                        $select.css({
                            top: Math.round(pos.top) + 37,
                            left: Math.round(pos.left)
                        }).show();

                        $('li:not(.other)', $select).on('click', function() {
                            self.setQty($parent, $(this).text());
                            self.closeSelect();
                        });
                    }

                    $('li.other input', $select)
                        .on('keyup blur', function(e) {
                            var num = $(this).val().replace(/\D/g, '');
                            $(this).val(num);

                            switch (e.keyCode) {
                                // enter/return
                                case 13:
                                    self.setQty($parent, num);
                                    self.closeSelect();
                                break;
                                // esc
                                case 27:
                                    self.closeSelect();
                                break;
                            }
                        })
                        .on('focus', function() {
                           // disable the document mousdown handler so the blur event will take precedence
                           $('body,.carousel').off('mousedown touchstart');
                        })
                        .on('blur', function() {
                            if ($(this).val()) {
                                self.setQty($parent, $(this).val());
                                self.closeSelect();
                            }
                        });

                    // close the select drop-down when anything else is clicked
                    $('body,.carousel').off().on('mousedown touchstart', function(e) {
                        // ignore on the select-list element or quantity field inside it (other)
                        if (e.target.parentElement.id != 'select-list' && e.target.parentElement.className != 'other') {
                            self.closeSelect();
                            $('body,.carousel').off('mousedown touchstart');
                        }
                    });
                });

                // close the help popup if carousel is dragged
                $('.carousel').off().on('mousedown touchstart', function(e) {
                    app.page.closeTip();
                });

                $('.variants-wrapper select').on('touchstart mousedown', function(e) {
                    $(this).focus();
                });

                // handle variant options switching
                $('.variants-wrapper select').change(function(e) {
                    self.switchVariant($(this).data('family'), $(this).val());

                    app.ga.pushData({
                        event: 'selectVariant',
                        selection: this.value
                    });
                });

                $('.variants-wrapper select').each(function() {
                    self.switchVariant($(this).data('family'), $(this).find(':selected').val());
                });
            }

            $('#my-products').addClass('loaded');
            app.cart.init(products);
        },

        /**
         * Updates a carousel's counter
         */
        updateCarouselCounter: function(carousel) {
            var current = carousel.currentSlide < 0 ? carousel.innerElements.length + (carousel.currentSlide + 1) : carousel.currentSlide + 1,
                counter = current +' '+ app.main.lang('product_carousel_counter') +' '+ carousel.innerElements.length;

            $('.slider-counter', $(carousel.selector).parent()).text(counter);
/*
            if (carousel.perPage > 2) {
                if (current == 1) {
                    $('.control.prev', $(carousel.selector).parent()).addClass('is-disabled');

                } else {
                    $('.control.prev', $(carousel.selector).parent()).removeClass('is-disabled');
                }

                if (current == (carousel.innerElements.length + 1) - carousel.perPage) {
                    $('.control.next', $(carousel.selector).parent()).addClass('is-disabled');

                } else {
                    $('.control.next', $(carousel.selector).parent()).removeClass('is-disabled');
                }
            }
*/
        },

        /**
         * Triggered when a variant is switched, also on page load to make sure proper variant is enabled
         */
        switchVariant: function(family, item_id) {
            var pws_item_divid = '#pws-item-' + family,
                product = self.getProductByID(item_id, 'item_id');

            $(pws_item_divid +' .product-name').text(product.name +' - '+ product.variant);

            // update image and part number aka SKU
            $(pws_item_divid +' img.product-image').attr('src', $(pws_item_divid).find(':selected').data('img'));
            $(pws_item_divid +' .price-info .part-number').text(product.part_number);

            // switch part_number data value for learn-more link
            $(pws_item_divid +' .learn-more').attr('data-part-number', product.part_number);

            // check tax_inclusive_pricing_enabled to descide which price to use
            $(pws_item_divid +' .price-info .retail').text(
                app.global.currency(
                    app.main.getSettings().tax_inclusive_pricing_enabled ? product.retail_price_with_tax : product.retail_price
                )
            );

            if (product.price_after_discount) {
                $(pws_item_divid +' .price-info .discount').text(app.global.currency(product.price_after_discount));
            }

            $(pws_item_divid +' .price-info .wholesale').text(
                app.global.currency(
                    app.main.getSettings().tax_inclusive_pricing_enabled ? product.wholesale_price_with_tax : product.wholesale_price
                )
            );

            var pv_value = product.point_value || product.retail_point_value;

            if (pv_value) {
                $(pws_item_divid +' .price-info .pv').text(app.global.round(pv_value));
            }

            if (app.main.getSettings().skavaEnabled) {
                // enable/disable subscription option
                var $radioOneTime = $('#'+ product.product_id +'-one-time-order'),
                    $radioSubscription = $('#'+ product.product_id +'-subscription-order');

                if (product.subscription) {
                    $radioSubscription.parent().show();
                    // $radioSubscription.trigger('click');

                } else {
                    $radioSubscription.parent().hide();
                    $radioOneTime.trigger('click');
                }
            }

            // for add-to-cart to work, the pws-item object must exist when cart is initialized (and YoungLiving.loadVoWidgets is called)
            // the add-to-cart button will always fire with the values set at time cart is initialized
            // so showing/hiding the buttons associated w/the variants
            $(pws_item_divid +' pws-item').removeClass('active');
            $('#cart-item-'+ item_id).addClass('active');

            // show/hide out of stock message or select checkbox depending on in_stock
            if (product.in_stock) {
                $('.add-to-cart', pws_item_divid).show();
                $('.out-of-stock', pws_item_divid).hide();

            } else {
                $('.add-to-cart', pws_item_divid).hide();
                $('.out-of-stock', pws_item_divid).show();
            }
        },

        /**
         * Search for a product with given ID and return it
         * @function getProductByID
         * @param {integer} id A product's item_id, product_id or part_number to search for. See the type param
         * @param {string} A field name to search for - item_id, product_id, part_number
         * @returns {object} Returns the product if found, otherwise returns false
         * @todo Move this to the main product module (when it's ready)
         */
        getProductByID: function(id, type) {
            if (!type) {
                type = 'product_id';
            }

            if (typeof id == 'object') {
                id = id.product_id;
            }

            var product = defiant.json.search(products, '//*['+ type +'="'+ id +'"]')[0];

            if (product) {
                if (app.products.isOnSale(product) && product.in_stock == false) {
                    return false;
                }
                return product;
            }

            return false;
        },

        /**
         * Get a category by ID
         */
        getCategoryByID: function(id) {
            for (var i=0; i<categories.length; i++) {
                if (categories[i].id == id) {
                    return categories[i];
                    //break;
                }
            }
        },

        /**
         * Is this being loaded inside an iframe?
         */
        inIframe: function() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },

        /**
         * Listen for postMessage() events from the parent window
         */
        messageHandler: function(data) {
            if (data === undefined) {
                return false;
            }

            var vals, msgType, msgData;

            try {
                // my messages
                vals = data.split('|');
                msgType = vals.shift();
                msgData = vals.join('|');

            } catch (e) {
                // others
                return;
            }

            switch (msgType) {
                case 'profile':
                case 'profile-enrollment':
                    preview = true;
                    var profile = JSON.parse(msgData);

                    if (!profile.profile_image) {
                        profile.profile_image = '/img/profile-default.jpg';

                    } else {
                        profile.profile_image = assetURL[mode] + profile.profile_image + cb;
                    }

                    app.main.setProfile(profile);
                    app.main.loadLanguageData(profile.culture);
                break;
                case 'revieworder':
                    // remove edit buttons
                    $('body').addClass('revieworder');
                break;
                case 'contact-form-ready':
                    $('#form-contact input').on('change blur', function() {
                        if ($(this).hasClass('error')) {
                            self.validateContactForm();
                        }
                    });

                    // submit contact form info via iframe
                    $('#btn-submit').off().on('click', function(e) {
                        e.preventDefault();

                        // validate on front end first
                        if (self.validateContactForm()) {

                            var iframe = document.getElementById('contact-form');
                            iframe.contentWindow.postMessage('submit|'+ JSON.stringify({
                                name: $('#field-name').val(),
                                email: $('#field-email').val(),
                                phone: $('#field-phone').val()
                            }), '*');

                            ga('send', 'event', 'Forms', 'submit', 'Contact Form');
                        }

                    });
                break;
                case 'contact-form-error':
                    // this only happens if front-end validation misses something that the back end catches
                    var errors = msgData.split(',');

                    for (var i=0; i<errors.length; i++) {
                        $('#field-'+ errors[i]).addClass('error');
                        $('.field-error.'+ errors[i]).text('Please verify your '+ errors[i]).show();
                    }
                    $('#field-name').focus();
                break;
                case 'message-sent':
                    $('#form-contact').fadeOut('fast', function() {
                        $('#contact-message').html('<i></i>'+ app.main.lang('contact_confirmation')).fadeIn('fast');
                    });
                break;
            }
        },

        /**
         * Basic validation for the contact form
         */
        validateContactForm: function() {
            var valid = true,
                fields = ['name', 'email', 'phone'];

            $('#form-contact input').removeClass('error');
            $('.field-error').empty().hide();

            if (self.validateEmail($('#field-email').val()) == false) {
                $('#field-email').addClass('error');
                $('.field-error.email').text(app.main.lang('error_email_invalid')).show();
                valid = false;
            }

            for (var i=0; i<fields.length; i++) {
                if ($('#field-'+ fields[i]).val() == '') {
                    $('#field-'+ fields[i]).addClass('error');
                    $('.field-error.'+ fields[i]).text(app.main.lang('error_required_field')).show();
                    valid = false;
                }
            }

            return valid;
        },

        /**
         * Valid email address?
         */
        validateEmail: function(email) {
            var re = /^([\w%+-]+(?:\.[\w%+-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return re.test(email);
        },

        /**
         * Validate a full url
         */
        validateURL: function(url) {
            var re = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g);
            if (re == null) {
                return false;
            }
            return true;
        },

        validatePhone: function(str) {
            // this is the same as the back-end validation
            var re = /^\+?\d{0,15}$/;

            // remove all non-numeric chars
            str = str.replace(/\D/g, '');

            if (str && re.test(str)) {
                return true;
            }

            return false;
        },

        /**
         * Any special logic for preview mode goes here
         */
        initPreview: function() {
            $('body').addClass('preview');
            $('.button-add-to-calendar').off('click');
            $('a').on('click', function(e) {
                e.preventDefault();
            });

            $('.btn-edit-url').on('click', function() {
                self.postMessage('edit-url');
            });

            $('.btn-edit-theme').on('click', function() {
                self.postMessage('edit-theme');
            });

            $('#btn-edit-profile').on('click', function() {
                self.postMessage('edit-profile');
            });

            $('#btn-edit-events').on('click', function() {
                self.postMessage('edit-events');
            });
        },

        /**
         * Send a message to the parent window
         */
        postMessage: function(data) {
            if (self.inIframe()) {
                window.parent.postMessage(data, '*');
            }
        },

        /**
         * Combines and parses the date and time fields
         */
        parseEvent: function(event) {
            var profile = app.main.getProfile(),
                start = new Date(event.start_date_time),
                end = new Date(event.end_date_time),
                // dateFormat = ['lt-lt'].includes(app.main.getCurrentCulture()) ? 'YYYY-MM-DD' : 'MMMM D, YYYY', // 2020-09-01 or September 1, 2017
                dateFormat = ['lt-lt'].includes(app.main.getCurrentCulture()) ? 'D MMMM YYYY' : 'MMMM D, YYYY', // 1 September 2020 or September 1, 2017
                countriesWith12hrTime = ['us', 'ca', 'gb', 'au', 'nz'],
                countryIs12hrTime = countriesWith12hrTime.indexOf(profile.country) != -1,
                timeFormat12hr = 'h:mm A', // 8:15 AM
                timeFormat24hr = 'HH:mm', // 08:15
                timeFormat = countryIs12hrTime ? timeFormat12hr : timeFormat24hr;

            event.start_date = moment(start).format(dateFormat);
            event.start_time = moment(start).format(timeFormat);
            event.end_date = moment(end).format(dateFormat);
            event.end_time = moment(end).format(timeFormat);

            if (moment(end).isAfter(start, 'day')) {
                event.multiday = true;
            } else {
                event.multiday = false;
            }

            // todo: this should be allday=true if start/end dates are the same and both times to 00:00, assuming times were never chosen
            // otherwise treat it like just a start time with no end time if both times are 05:30 for instance
            if (moment(start).isSame(end)) {
                event.allday = true;
            } else {
                event.allday = false;
            }

            // Set each public event to private if it's more than 2 days old
            if (moment().subtract(2, 'days').isAfter(end) && event.public) {
                event.public = false;
            }

            return event;
        },

        /**
         * Has this page been loaded? For checking whether we can scroll to events/contact/products
         */
        isLoaded: function() {
            return loaded;
        },

        /**
         * Preview mode value
         */
        isPreview: function() {
            return preview;
        },

        /**
         * Close and disable and product quantity select lists
         */
        closeSelect: function() {
            $(window).off('resize', self.closeSelect);
            $('.select').removeClass('is-active');
            $('#select-list li').off('click');
            $('#select-list .other input').val('').off('keyup blur');
            $('#select-list').hide();
            app.page.closeTip();
        },

        /**
         * Sets the quantity value based on selection or 'other' field entry
         */
        setQty: function($parent, num) {
            num = parseInt(num, 10);

            if (num < 1 || isNaN(num)) {
                return;
            }
            $('.selected', $parent).text(num);
            $('.field-quantity', $parent).val(num);
        }
    };

    return self;
}());